export default __webpack_public_path__ + "static/media/diamond_reflection.61656af2.png";